import { TFormFieldData } from '@gismart/ui.library/core/types'
import { isVariantField } from './isVariantField'

export const getFormFieldsWithoutThirdStepFields = (
  fields: TFormFieldData[],
): TFormFieldData[] => fields.filter((field) => !isVariantField(field.name[0]))
